import { render, staticRenderFns } from "./MainApp.vue?vue&type=template&id=4c0134e7&scoped=true"
import script from "./MainApp.vue?vue&type=script&lang=ts"
export * from "./MainApp.vue?vue&type=script&lang=ts"
import style0 from "./MainApp.vue?vue&type=style&index=0&id=4c0134e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0134e7",
  null
  
)

export default component.exports